import clsx from 'clsx';
import React from 'react';

import type { IconProps } from './icon-types';
import styles from './IconBase.module.css';

type IconBaseProps = React.PropsWithChildren<
    IconProps & {
        viewBox?: string;
    }
>;

export const IconBase = React.forwardRef<SVGSVGElement, IconBaseProps>(function IconBase(
    {
        size = 24,
        color,
        className,
        style,
        decorative = true,
        dirSensitive = false,
        children,
        title,
        viewBox = '0 0 24 24',
        'aria-label': ariaLabel,
        ...rest
    },
    ref
) {
    const accessibilityProps = decorative
        ? { 'aria-hidden': true as const, role: undefined }
        : { 'aria-label': ariaLabel, role: 'img' as const };

    return (
        <svg
            ref={ref}
            viewBox={viewBox}
            width={size}
            height={size}
            focusable="false"
            className={clsx(styles.icon, { [styles.dirSensitive]: dirSensitive }, className)}
            style={{ color, ...style }}
            {...accessibilityProps}
            {...rest}
        >
            {title ? <title>{title}</title> : null}
            {children}
        </svg>
    );
});
